// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { truncate } from 'fs';

export const environment = {
  production: true,
  // authApiUrl: 'https://localhost:44325',
  // authApiUrl: 'https://authrestapidev.superentegrator.com:8443',
  // adminApiUrl: 'https://localhost:44359',
  //KErem- adminApiUrl : 'https://localhost:44312'
  // adminApiUrl: 'https://adminpanelapidev.superentegrator.com:8443',
  // sysAdminVKN: '1234567890'

  company:
    window['env'] && window['env']['company'] ? window['env']['company'] : '',
    authApiUrl:
    window['env'] && window['env']['authApiUrl'] ? window['env']['authApiUrl'] : '',
  adminApiUrl:
    window['env'] && window['env']['adminApiUrl']
      ? window['env']['adminApiUrl']
      : '',
  sysAdminVKN:
    window['env'] && window['env']['sysAdminVKN']
      ? window['env']['sysAdminVKN']
      : '',
  isEnvironment:
    window['env'] && window['env']['isEnvironment']
      ? window['env']['isEnvironment']
      : '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
